/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Leave Service API
 * Leave management microservice (multi-step approvals, delegation, holidays)
 * OpenAPI spec version: v1
 */

/**
 * Optional supervision level filters (MANAGER, DIRECTOR, HR, CEO, NON_SUPERVISOR)
 */
export type LeaveEntitlementRuleCreateDtoSupervisionLevelsItem =
  (typeof LeaveEntitlementRuleCreateDtoSupervisionLevelsItem)[keyof typeof LeaveEntitlementRuleCreateDtoSupervisionLevelsItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LeaveEntitlementRuleCreateDtoSupervisionLevelsItem = {
  NUMBER_0: "0",
  NUMBER_1: "1",
  NUMBER_2: "2",
  NUMBER_3: "3",
  NUMBER_4: "4",
} as const;
